import { MinuAmetnik } from '@/models/Ametnik';
import { AxiosTeenus } from './axios-teenus';

export class IsikuandmeTeenus {

    public async minuAmetnikuInfo(): Promise<MinuAmetnik> {
        const axios = new AxiosTeenus();
        const response = await axios.get<MinuAmetnik>(`/api/minuametnik/ametnikuinfo`);
        return response?.data;
    }

    public async kinnitaTingimused(): Promise<string[]> {
        const axios = new AxiosTeenus();
        const response = await axios.post(`/api/kasutamisetingimused/kinnitatigimused`);
        return response?.data as string[];
    }    
}